// components/SectionManager.js
import React from 'react';
import { Button, InputField } from '@dhis2/ui';
import SubSectionManager from './SubSectionManager';

const SectionManager = ({ 
  department, 
  onAddSection, 
  onRemoveSection, 
  onUpdateSectionInput,
  onUpdateSection 
}) => {
  return (
    <div style={{ marginLeft: '10px' }}>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '15px', alignItems: 'flex-end' }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: '500', marginBottom: '4px', fontSize: '14px' }}>Add Section to {department.name}</div>
          <InputField
            value={department.newSection || ''}
            onChange={({ value }) => onUpdateSectionInput(value)}
            placeholder="Section name"
            fullWidth
          />
        </div>
        <Button small onClick={onAddSection} disabled={!department.newSection?.trim()}>
          Add Section
        </Button>
      </div>

      {department.sections?.map(section => (
        <div key={section.id} style={{ marginBottom: '15px', padding: '12px', border: '1px solid #eee', borderRadius: '4px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ fontWeight: '500' }}>{section.name}</span>
            <Button small destructive onClick={() => onRemoveSection(section.id)}>
              Remove Section
            </Button>
          </div>

          <SubSectionManager
            section={section}
            onAddSubSection={() => onUpdateSection(section.id, 'addSubSection')}
            onRemoveSubSection={(subSectionId) => onUpdateSection(section.id, 'removeSubSection', subSectionId)}
            onUpdateSubSectionInput={(value) => onUpdateSection(section.id, 'updateSubSectionInput', value)}
          />
        </div>
      ))}
    </div>
  );
};

export default SectionManager;